interface IProps {
    children?: any,
}

export const PagesTable = (props: IProps) => {

    return (
        <div className="table-responsive">
            <table className="table table-centered">
                <thead className="thead-light">
                    <tr>
                        <th>Datum</th>

                        <th>Název</th>

                        <th>Sekce</th>

                        <th>Kategorie</th>

                        <th>Zdroj</th>
  
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>)
}